define('model/template.object.type.model',['require','exports','module','fukit'],function(require, exports, module) {
  var BaseModel = require('fukit').BaseModel;

  var TemplateObjectType = BaseModel.extend({
    radioRequests: {
      'models TemplateObjectType': '@constructor',
    },

    urlRoot: '/api/v1/eform/templateObjectType',
  });

  module.exports = TemplateObjectType;
});

